import { Order } from "../models";
import { OrderType } from "../types/order/IOrder";
import { Timestamp } from "../types";

/** Fallback: determine if an order looks like a price request from a missing productId. */
export const inferPriceRequest = (order: Order): boolean => {
  if (!order.cargo || order.cargo.length === 0) return true;
  return order.cargo.some(
    (item: any) => !item.productId || item.productId.trim() === "",
  );
};

/** Determine OrderType with backward-compatibility for legacy orders. */
export const getOrderType = (order: Order): OrderType => {
  if (order.orderType) return order.orderType as OrderType;
  return inferPriceRequest(order)
    ? OrderType.PriceRequest
    : OrderType.PublicOrder;
};

/**
 * Format a timestamp Gmail-style: time only if today, otherwise the date.
 * @param noDateLabel - Localized label returned when there is no timestamp.
 */
export const formatGmailStyle = (
  timestamp: any,
  noDateLabel: string,
): string => {
  if (!timestamp) return noDateLabel;

  const today = new Date();
  const timestampDate = timestamp.toDate();
  const isToday = today.toDateString() === timestampDate.toDateString();

  if (isToday) {
    return Timestamp.ToDisplayTime(timestamp);
  } else {
    return Timestamp.toDisplayDate(timestamp);
  }
};

/** Format a price value in NOK with two decimals (e.g. "1 234,00 kr"). */
export const formatPrice = (price?: number | null): string => {
  if (price === undefined || price === null) return "0,00 kr";
  return (
    new Intl.NumberFormat("nb-NO", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(price) + " kr"
  );
};
